import ContactsPageView from "./ContactsPageView";

function ContactsPage() {
  return <ContactsPageView />;
}

export default ContactsPage;
